define('ordersDetailOrderClientCommentsWindowView',[
  'module',
  'marionette',
  'underscore',
  'ordersDetailOrderClientCommentsView',
  'template!ordersDetailOrderClientCommentsWindowView'
], function (
  Module,
  Marionette,
  _,    
  CommentsView,
  Tpl
) {
  'use strict';   

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-order-client-comments-window-view',

    regions: {
      commentsRegion: '.comments-region'
    },

    onRender: function () {
      this.commentsRegion = new CommentsView({
        model: this.model
      });
      this.getRegion('commentsRegion').show(this.commentsRegion);
    }
  });    
});
